import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, effect } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet, RouterLink, RouterLinkActive, Router } from '@angular/router';
import { UserInfo } from '../user-info/user-info';
import {  UserService } from '../user.service';
import { WorkRequestService } from '../work-request';
import { JobLocation, makeBlankTenantView, ReasonRequest, ReportedLocation, TenantView, TenantWorkOrderRequest } from '../models';
import { NG_ModalService } from '../bootstrap/modal/modalSvc.service';
import { ModalContent } from '../bootstrap/modal/modal';
import { CappyLoader } from "../cappy-loader/cappy-loader";
import { PropertyOverviewWidget } from '../homepage/property-overview-widget/property-overview-widget';

@Component({
	selector: 'app-request-work-orders',
	imports: [RouterOutlet, RouterLink, RouterLinkActive, FormsModule, CommonModule, UserInfo, CappyLoader, PropertyOverviewWidget],
	templateUrl: './request-work-orders.html',
	styleUrl: './request-work-orders.scss'
})
export class RequestWorkOrdersComponent {
	safeMapUrl: SafeResourceUrl | null = null;
	loadedOptions = false;
	currentTenant : TenantView = makeBlankTenantView();

	language: number = 2;

	selectedResonForRequest: ReasonRequest	 | null = null;
	selectedJobLocation: JobLocation | null = null;
	selectedReportedLocation: ReportedLocation | null = null;

	maxFiles = 3;
	formDescription: any;
	isEmergency: any;

	public filteredJobLocations:  JobLocation[] = [];


	constructor(public _wr: WorkRequestService, 
		public userService: UserService, 
		public router: Router, 
		protected _cd: ChangeDetectorRef,
		private sanitizer: DomSanitizer,
		protected modalSvc: NG_ModalService) {
		effect(() => {
			this.language = this.userService.currentTennant()?.Language || 2;
			const mapUrl = "www.google.com/maps?q=" + this.userService.currentTennant()?.Region + ", " + this.userService.currentTennant()?.City + ", " + this.userService.currentTennant()?.Address + "&output=embed";
			if (mapUrl) {
				this.safeMapUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://' + mapUrl);
			}
			console.log('Current tenant changed in RequestWorkOrdersComponent:', this.userService.currentTennant());
			this.currentTenant = this.userService.currentTennant();
			console.log('Current tenant set in RequestWorkOrdersComponent:', this.currentTenant);
			if (this.currentTenant && !this.loadedOptions) {
				//ready to rock
				this.loadedOptions = true;
				let language = this.userService.currentTennant()?.Language || 1;
				this._wr.loadRequestOptions(language, true).then(() => {
					this._cd.detectChanges();
				});
				//reset the new request with the current tenant info
				this._wr.resetNewRequest( this.currentTenant );

			}
			this._cd.detectChanges();
		});
	}

	public ContentStrings : Record<string, Record<number, string>> = {
		RequestWorkOrder: { 1: "Request Work", 2: "作業を依頼する" },
		ReasonForRequest: { 1: "Reason for Request", 2: "リクエストの理由" },
		SelectReasonForRequest: { 1: "Select Reason for Request", 2: "リクエストの理由を選択してください" },
		ReportedArea: { 1: "Reported Area", 2: "報告されたエリア" },
		SelectReportedArea: { 1: "Select reported area", 2: "報告されたエリアを選択してください" },
		JobLocation: { 1: "Job Location", 2: "作業場所" },
		SelectJobLocation: { 1: "Select job location", 2: "作業場所を選択してください" },
		Description: { 1: "Description", 2: "説明" },
		Emergency: { 1: "Emergency", 2: "緊急" },
		EmergencyCheckText: { 1: "Check here if this is an emergency request", 2: "これが緊急のリクエストである場合はチェックしてください" },
		AddPhoto: { 1: "Add Photo", 2: "写真を追加" },
		ChooseFiles: { 1: "Choose Files", 2: "ファイルを選択" },
		AttachedImages: { 1: "Attached Images", 2: "添付画像" },
		NoImagesUploaded: { 1: "No images uploaded", 2: "画像がアップロードされていません" },
		SubmitRequest: { 1: "Submit Request", 2: "リクエストを送信" },
		RequiredField: { 1: "Required field", 2: "必須項目" },
	};

	async ngOnInit() {
		
	}

	onReasonForRequestChange(event: any) {
		const value = event.target.value;
		let reason = this._wr.ReasonRequests()[value];
		this.selectedResonForRequest = reason;
		console.log('Selected Reason For Request:', value, reason);
		this._wr.newRequest.update( (prev) => {
			let newObj = structuredClone( prev );
			newObj.Reason_for_request_id = reason.id;
			newObj.Reason_for_request_name = reason.LABEL;
			return newObj;
		});
		this._cd.detectChanges();
		//this._wr.newRequest().Reason_for_request_id = reason.id;
		//this._wr.newRequest().Reason_for_request_name = reason.LABEL;
	}

	onJobLocationChange(event: any) {
		const value = event.target.value;
		console.log('Selected Job Location:', value);
		let loc = this._wr.JobLocations()[value];
		this.selectedJobLocation = loc;
		console.log('Data is:', loc);
		this._wr.newRequest().Job_location_id = loc.id;
		this._wr.newRequest().Job_location_name = loc.LABEL;
		this._cd.detectChanges();
	}

	onReportedAreaChange(event: any) {
		const value = event.target.value;
		console.log('Selected Reported Area:', value);
		let loc = this._wr.ReportedLocations()[value];
		this.selectedReportedLocation = loc;
		console.log('Data is:', loc);	

		this.filteredJobLocations = [];
		this._wr.JobLocations().forEach( (jobLoc) => {
			if ( jobLoc.reported_location == loc.id) {
				this.filteredJobLocations.push(jobLoc);
			}
		});

		this._wr.newRequest().Reported_location_id = loc.id;
		this._wr.newRequest().Reported_location_name= loc.LABEL;

		this._cd.detectChanges();
	}
	
	onDescriptionChange(event: any) {	
		const value = event.target.value;
		this.formDescription = value;
		this._wr.newRequest().Description = value;
	}

	onEmergencyChange(event: any) {
		const isChecked = event.target.checked;
		this.isEmergency = isChecked;
		this._wr.newRequest().Emergency = isChecked;
	}

	onFileChange(event: any) {
		const input = event.target as HTMLInputElement;
		const files: FileList | null = input.files;
		console.log('Selected files:', files);
		if (files) {
			for (let i = 0; i < files.length; i++) {
				const file = files[i];
				if (this._wr.newRequestImages().length >= this.maxFiles) {
					alert('You can only upload up to ' + this.maxFiles + ' files.');
					return;
				}
			}
		}
		if (files && files.length > 0) {
			this._wr.newRequestImages.update((previousArray) => {
				let fileLen = files.length > 3 ? 3 : files.length;
				for (let i = 0; i < fileLen; i++) {
					const file = files[i];
					previousArray.push(file);
				}
				let newArray = structuredClone(previousArray);
				return newArray;
			});
			console.log(this._wr.newRequestImages());
			this._cd.markForCheck();
		}
		input.value = ''; // Reset input so change event fires again
	}

	getImageUrl(file: File): string {
		return URL.createObjectURL(file);
	}

	removeFile(index: number) {
		this._wr.newRequestImages.update((previousArray) => {
			previousArray.splice(index, 1);
			let newArray = structuredClone(previousArray);
			return newArray;
		});
		this._cd.markForCheck();
	}

	async submitRequest() {

		this._wr.newRequest.update( (prev) => {
			prev.Reason_for_request_id = 5292;
			prev.Reason_for_request_name = 'On-demand Repair Interior'
			let newObj = structuredClone( prev );
			return newObj;
		});

		let modalContent: ModalContent = {
			title: 'Submitting Request',
			bodyStrings: ['Please wait while your request is being submitted...'],
			buttons: [{
				text: 'Close',
				className: 'btn btn-secondary',
				close: true
			}],
			injectedComponent: CappyLoader,
			injectedInputs: { viewType: 'REGULAR_LOADING', verbiage: 'Request Submitted' }
		};
		this.modalSvc.setContent(modalContent);

		this.modalSvc.showModal();

		this._cd.detectChanges();
		
		this._wr.newRequest.update( (prev: TenantWorkOrderRequest )=>{

			let incompleteReq = structuredClone(prev);
			incompleteReq.Building_id = this.currentTenant.Building_id;
			incompleteReq.Tenant_id = this.currentTenant.Tenant_id;
			incompleteReq.Unit_id = this.currentTenant.Unit_id;
			incompleteReq.Last_name = this.currentTenant.Last_name;
			incompleteReq.Work_order_type_id = 1; //always 1 for now
			incompleteReq.Street_address = this.currentTenant.Street_address;
			incompleteReq.City = this.currentTenant.City;
			incompleteReq.Region = this.currentTenant.Region;
			return incompleteReq;
		});

		console.log( this._wr.newRequest());


		let resp = await this._wr.submitNewRequest();
		console.log(resp);
		if ( !resp.success ) {
			this.modalSvc.hideModal();
			alert('Error submitting request: ' + resp.error + '. If the problem persists, please report this error directly to your property management team!');
			return;
		}
		else {
			//alert('Request submitted successfully! Your work order request number is ' + (resp.data?.Work_order_id || resp.data?.tenant_work_order_requests.Work_request_id) + '. You will be redirected to your work orders page.');
			this.modalSvc.hideModal();
			setTimeout(() => {
				modalContent = {
					title: 'Request Submitted',
					bodyStrings: ['Your request has been submitted successfully! Your work order request number is:'],
					bodyHtml: `
					<div style="width:100%; text-align:center">
						<h3>` + resp.data?.Work_request_id + `</h3>
					</div>`,
					buttons: [{
						text: 'Close',
						className: 'btn btn-primary',
						close: true,
						callback: () => {
							//this.resetForm();
							//send to route my-work-orders
							this.router.navigate(['/my-work-orders']);
						}
					}]
				};
				this.modalSvc.setContent(modalContent);
				this.modalSvc.showModal();
				this.resetForm();
				this._cd.detectChanges();

			}, 1500);
		}
	}

	resetForm() {
		console.log('Resetting form');
		this._wr.resetNewRequest( this.currentTenant );
		this.selectedJobLocation = null;
		this.selectedResonForRequest = null;
		this.selectedReportedLocation = null;
		this.isEmergency = false;
		this.formDescription = '';
		this._cd.detectChanges();
	}

}
